import { X } from "lucide-react";
import { freshModal } from "../freshModal";
import { useState, useEffect, useRef } from "react";
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogTitle,
} from "./Dialog";
import { Button } from "./Button";
import { Input } from "./Input";
import { Label } from "./Label";
import { Textarea } from "./Textarea";

import {
  Select,
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
  SelectTrigger,
  SelectValue,
} from "./Select";
import { format } from "date-fns";
import { message } from "antd";
import axios from "../../axios/AxiosInstance";
import MultiSelect from "./MultiSelect";

function TaskModalFormSession({
  open,
  isUpdating,
  task,
  onOpenChange,
  updateOnCreate,
  takers,
}) {
  const [clientSearch, setClientSearch] = useState("");
  const [candidateSearch, setCandidateSearch] = useState("");
  const [clients, setClients] = useState([]);
  const [selectedUsers, setSelectedUsers] = useState([]);
  const [candidates, setCandidates] = useState([]);
  const [showClientDropdown, setShowClientDropdown] = useState(false);
  const [showCandidateDropdown, setShowCandidateDropdown] = useState(false);
  const [isLoadingClient, setIsLoadingClient] = useState(false);
  const [isLoadingCandidate, setIsLoadingCandidate] = useState(false);
  const [timer, setTimer] = useState(null);

  /*   const searchClient = (query) => {
    setClientSearch(query);
    const results = clients.filter((client) =>
      client.name.toLowerCase().includes(query.toLowerCase())
    );
    setFilteredClients(results);
    setShowClientDropdown(true);
  }; */

  const searchClient = (word) => {
    console.log(word);

    setClientSearch(word);
    if (word.length === 0) {
      setClients([]);
    }
    if (word.length < 3) {
      if (timer) clearTimeout(timer);
    }
    if (word.length >= 3) {
      if (timer) clearTimeout(timer);

      const timer2 = setTimeout(() => {
        setIsLoadingClient(true);
        axios
          .post("client/freelance/find-by-text", { query: word })
          .then((res) => {
            setClients(res.data);
            setShowClientDropdown(true);
            console.log(res.data);
          })
          .catch((e) => console.log(e))
          .finally(() => setIsLoadingClient(false));
      }, 700);
      setTimer(timer2);
    }
  };

  const searchCandidate = (word) => {
    console.log(word);

    setCandidateSearch(word);
    if (word.length === 0) {
      setCandidates([]);
    }
    if (word.length < 3) {
      if (timer) clearTimeout(timer);
    }
    if (word.length >= 3) {
      if (timer) clearTimeout(timer);

      const timer2 = setTimeout(() => {
        setIsLoadingCandidate(true);
        axios
          .post("tempworker-candidate/freelance/find-by-text", { query: word })
          .then((res) => {
            setCandidates(res.data);
            setShowCandidateDropdown(true);
            console.log(res.data);
          })
          .catch((e) => console.log(e))
          .finally(() => setIsLoadingCandidate(false));
      }, 700);
      setTimer(timer2);
    }
  };
  const clientRef = useRef(null);
  const candidateRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (
        candidateRef.current &&
        !candidateRef.current.contains(event.target)
      ) {
        setShowCandidateDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (clientRef.current && !clientRef.current.contains(event.target)) {
        setShowClientDropdown(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  const userId = localStorage.getItem("userId");
  // Initial form state
  const [formData, setFormData] = useState({
    type: "",
    priority: "",
    date: undefined,
    hour: "",
    comment: "",
    clients: [],
    candidates: [],
    taskManager: "",
    taskManagers: [],
  });

  // Reset form when modal opens
  useEffect(() => {
    if (open) {
      if (isUpdating) {
        setSelectedUsers(
          (task.taskManagers || []).map((user) => user._id || user),
        );
        setFormData({
          type: task.type,
          priority: task.priority,
          date: new Date(task.date),
          hour: task.hour,
          comment: task.comment,
          clients: task.clients || [],
          candidates: task.candidates || [],
          taskManager: task.manager,
        });
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [open]);

  /*  const createTask = () => {
   
    const data = {}
    data.taskCreator = userId
    data.type = taskType
    data.date = date
    data.comment = comment
    data.taskManager = taker
   
    if (selectedClient) data.client = selectedClient._id
    if (selectedCandidate) data.candidate = selectedCandidate._id
    axiosInstance
      .post('task', data)
      .then((res) => {
        const newTasks = [res.data, ...tasks]
        setTasks(newTasks)
        message.success('Tâche créée ! ')
        resetTaskFields()
        setIsOpenCreateTask(false)
      })
      .catch((e) =>{
        console.log(e); 
        message.error("Une erreur s'est produite ! ")
        })
  } */

  // Sample data (in real app, this would come from an API or props)
  const taskTypes = [
    { id: "5", name: "Administratif" },
    { id: "578963", name: "Appel" },
    { id: "5469", name: "Autre" },
    { id: "1", name: "Entretien" },
    { id: "54788", name: "Information" },

    { id: "78932", name: "Prospection" },
    { id: "4", name: "Recrutement" },
    { id: "3", name: "Relance" },

    { id: "2", name: "Suivi" },

    { id: "7893244", name: "Visite client" },
  ];

  const priority = [
    { id: "1", name: "Urgent" },
    { id: "2", name: "Haute" },
    { id: "3", name: "Moyenne" },
    { id: "4", name: "Basse" },
  ];

  const handleSubmit = (e) => {
    e.preventDefault();
    if (isFormComplete() && selectedUsers.length > 0) {
      // Do your POST
      formData.taskCreator = userId;
      console.log(formData);
      console.log(selectedUsers);
      createTask();
      console.log("Form is complete, posting...");
    } else {
      console.log("Please fill all fields before submitting.");
    }
  };

  const createTask = () => {
    const sentData = { ...formData };
    sentData.clients = sentData.clients.map((client) => client._id || client);
    sentData.candidates = sentData.candidates.map(
      (candidate) => candidate._id || candidate,
    );
    sentData.taskManagers = selectedUsers;
    const request = isUpdating
      ? axios.put(`newtask/${task._id || task.id}`, sentData)
      : axios.post("newtask", sentData);
    request
      .then((res) => {
        console.log(res.data);
        updateOnCreate(res.data);
        onOpenChange(false);
        setSelectedUsers([]);
        message.success(isUpdating ? "Tâche mise à jour !" : "Tâche créée !");
      })
      .catch((e) => {
        console.log(e);
        message.error("Une erreur s'est produite ! ");
      });
  };

  const isFormComplete = () => {
    const { type, priority, date, hour } = formData;
    console.log(type);
    console.log(priority);
    console.log(date);
    console.log(hour);
    return type !== "" && priority !== "" && date !== undefined && hour !== "";
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="sm:max-w-[620px] max-w-[calc(100vw-2rem)] p-0 overflow-hidden bg-white rounded-2xl border border-slate-200 shadow-xl">
        <div className="relative border-b border-slate-200 bg-white px-6 py-5 pr-16">
          <button
            type="button"
            aria-label="Fermer"
            onClick={() => onOpenChange(false)}
            className="absolute right-5 top-5 rounded-lg p-2 text-slate-500 hover:bg-slate-100 hover:text-slate-800"
          >
            <X size={20} />
          </button>
          <DialogTitle className="text-xl font-semibold text-slate-900 mb-2">
            {isUpdating ? "Modifier la tâche" : "Nouvelle tâche"}
          </DialogTitle>
          <DialogDescription className="text-slate-500">
            {isUpdating
              ? "Modifiez les informations et l’attribution de cette tâche."
              : "Organisez votre suivi et attribuez la tâche à votre équipe."}
          </DialogDescription>
        </div>

        <form onSubmit={handleSubmit} className="space-y-4 p-6 bg-white">
          <div className="grid grid-cols-1 gap-y-4 bg-white">
            {/* Task Type */}
            <div className="space-y-2">
              <Label
                htmlFor="taskType"
                className="text-sm font-medium text-slate-700"
              >
                Type de tâche
              </Label>
              <Select
                value={formData.type}
                onValueChange={(value) =>
                  setFormData({ ...formData, type: value })
                }
                className="bg-white text-black"
              >
                <SelectTrigger className="w-full border bg-white border-slate-200 rounded-lg text-slate-900">
                  <SelectValue placeholder="Sélectionner le type de tâche" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectLabel className="bg-white">
                      Types de tâches
                    </SelectLabel>
                    {taskTypes.map((type) => (
                      <SelectItem
                        className="bg-white text-black"
                        key={type.id}
                        value={type.name}
                      >
                        {type.name}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>

            <div className="space-y-2">
              <Label
                htmlFor="taskType"
                className="text-sm font-medium text-slate-700"
              >
                Priorité de la tâche
              </Label>
              <Select
                value={formData.priority}
                onValueChange={(value) =>
                  setFormData({ ...formData, priority: value })
                }
                className="bg-white"
              >
                <SelectTrigger className="w-full border bg-white border-slate-200 rounded-lg text-slate-900">
                  <SelectValue placeholder="Sélectionner le type de priorité" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectLabel className="bg-white">Priorité</SelectLabel>
                    {priority.map((prior) => (
                      <SelectItem
                        className="bg-white"
                        key={prior.id}
                        value={prior.name}
                      >
                        {prior.name}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select>
            </div>

            {/* Date and Time in a 2-column layout */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {/* Date Picker */}
              <div className="space-y-2">
                <Label
                  htmlFor="date"
                  className="text-sm font-medium text-slate-700"
                >
                  Date de la tâche
                </Label>
                <Input
                  id="date"
                  type="date"
                  required
                  value={
                    formData.date &&
                    !Number.isNaN(new Date(formData.date).getTime())
                      ? format(new Date(formData.date), "yyyy-MM-dd")
                      : ""
                  }
                  onChange={(event) =>
                    setFormData({
                      ...formData,
                      date: event.target.value
                        ? new Date(`${event.target.value}T12:00:00`)
                        : undefined,
                    })
                  }
                  className="w-full border border-slate-200 rounded-lg text-slate-900 bg-white"
                />
              </div>

              {/* Time Picker */}
              <div className="space-y-2">
                <Label
                  htmlFor="time"
                  className="text-sm font-medium text-slate-700"
                >
                  Heure de la tâche
                </Label>
                <div className="relative text-gray-400">
                  <Input
                    id="time"
                    type="time"
                    value={formData.hour}
                    onChange={(e) =>
                      setFormData({ ...formData, hour: e.target.value })
                    }
                    className="w-full border border-gray-300 rounded-md pl-10"
                  />
                </div>
              </div>
            </div>

            {/* Comment */}
            <div className="space-y-2">
              <Label
                htmlFor="comment"
                className="text-sm font-medium text-slate-700"
              >
                Commentaire
              </Label>
              <Textarea
                id="comment"
                value={formData.comment}
                onChange={(e) =>
                  setFormData({ ...formData, comment: e.target.value })
                }
                placeholder="Détails de la tâche..."
                className="min-h-[100px] border border-gray-300 rounded-md"
              />
            </div>

            {/* Client */}
            <div ref={clientRef} className="space-y-2">
              <Label
                htmlFor="client"
                className="text-sm font-medium text-slate-700"
              >
                Client(s) concerné(s)
              </Label>
              <div className="relative">
                <Input
                  value={clientSearch}
                  onChange={(e) => searchClient(e.target.value)}
                  placeholder="Rechercher le client"
                  className="w-full border border-gray-300 rounded-md pr-10"
                />
                {isLoadingClient && (
                  <div className="absolute inset-y-0 right-3 flex items-center">
                    <svg
                      className="animate-spin h-4 w-4 text-gray-500"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                  </div>
                )}
              </div>

              {showClientDropdown && clients.length > 0 && (
                <ul className=" z-10 mt-1 w-11/12 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto">
                  {clients.map((client) => (
                    <li
                      key={client._id}
                      onClick={() => {
                        console.log(formData);

                        const alreadySelected = formData.clients?.some(
                          (c) => c._id === client._id,
                        );

                        const updatedClients = alreadySelected
                          ? formData.clients.filter((c) => c._id !== client._id)
                          : [
                              ...formData.clients,
                              { _id: client._id, name: client.companyName },
                            ];

                        setFormData({ ...formData, clients: updatedClients });
                      }}
                      className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${
                        formData.clients?.some((c) => c._id === client._id)
                          ? "bg-sky-50 font-semibold"
                          : ""
                      }`}
                    >
                      {client.companyName}
                    </li>
                  ))}
                </ul>
              )}
              {formData.clients.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {formData.clients.map((client) => (
                    <span
                      key={client._id}
                      className="flex items-center bg-sky-50 text-[#074b78] text-sm font-medium px-3 py-1 rounded-full"
                    >
                      {client.name}
                      <button
                        type="button"
                        onClick={() => {
                          const updatedClients = formData.clients.filter(
                            (c) => c._id !== client._id,
                          );
                          setFormData({ ...formData, clients: updatedClients });
                        }}
                        className="ml-2 text-[#074b78] hover:text-[#063b5e] focus:outline-none"
                      >
                        &times;
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>

            <div ref={candidateRef} className="space-y-2">
              <Label
                htmlFor="client"
                className="text-sm font-medium text-slate-700"
              >
                Candidat(s) concerné(s)
              </Label>
              <div className="relative">
                <Input
                  value={candidateSearch}
                  onChange={(e) => searchCandidate(e.target.value)}
                  placeholder="Rechercher un candidat"
                  className="w-full border border-gray-300 rounded-md pr-10"
                />
                {isLoadingCandidate && (
                  <div className="absolute inset-y-0 right-3 flex items-center">
                    <svg
                      className="animate-spin h-4 w-4 text-gray-500"
                      xmlns="http://www.w3.org/2000/svg"
                      fill="none"
                      viewBox="0 0 24 24"
                    >
                      <circle
                        className="opacity-25"
                        cx="12"
                        cy="12"
                        r="10"
                        stroke="currentColor"
                        strokeWidth="4"
                      ></circle>
                      <path
                        className="opacity-75"
                        fill="currentColor"
                        d="M4 12a8 8 0 018-8v8H4z"
                      ></path>
                    </svg>
                  </div>
                )}
              </div>

              {showCandidateDropdown && candidates.length > 0 && (
                <ul className=" z-10 mt-1 w-11/12 bg-white border border-gray-200 rounded-md shadow-lg max-h-60 overflow-auto">
                  {candidates.map((candidate) => (
                    <li
                      key={candidate._id}
                      onClick={() => {
                        console.log(formData);

                        const alreadySelected = formData.candidates?.some(
                          (c) => c._id === candidate._id,
                        );

                        const updatedCandidates = alreadySelected
                          ? formData.candidates.filter(
                              (c) => c._id !== candidate._id,
                            )
                          : [
                              ...formData.candidates,
                              {
                                _id: candidate._id,
                                name:
                                  candidate.firstname +
                                  " " +
                                  candidate.lastname,
                              },
                            ];

                        setFormData({
                          ...formData,
                          candidates: updatedCandidates,
                        });
                      }}
                      className={`px-4 py-2 cursor-pointer hover:bg-gray-100 ${
                        formData.candidates?.some(
                          (c) => c._id === candidate._id,
                        )
                          ? "bg-sky-50 font-semibold"
                          : ""
                      }`}
                    >
                      {candidate.firstname} {candidate.lastname} -{" "}
                      <span className="italic">{candidate.phone}</span>
                    </li>
                  ))}
                </ul>
              )}
              {formData.candidates?.length > 0 && (
                <div className="flex flex-wrap gap-2 mt-2">
                  {formData.candidates.map((candidate) => (
                    <span
                      key={candidate._id}
                      className="flex items-center bg-sky-50 text-[#074b78] text-sm font-medium px-3 py-1 rounded-full"
                    >
                      {candidate.name}
                      <button
                        type="button"
                        onClick={() => {
                          const updatedCandidates = formData.candidates.filter(
                            (c) => c._id !== candidate._id,
                          );
                          setFormData({
                            ...formData,
                            candidates: updatedCandidates,
                          });
                        }}
                        className="ml-2 text-[#074b78] hover:text-[#063b5e] focus:outline-none"
                      >
                        &times;
                      </button>
                    </span>
                  ))}
                </div>
              )}
            </div>

            {/* Assigned To */}
            <div className="space-y-2">
              <Label
                htmlFor="taskManager"
                className="text-sm font-medium text-slate-700"
              >
                Attribuée à
              </Label>
              <MultiSelect
                options={takers.map((user) => ({
                  label: user.label,
                  value: user.value,
                }))}
                selected={selectedUsers}
                setSelected={setSelectedUsers}
              />
              {/*  <Select
                value={formData.taskManager}
                onValueChange={(value) => {
                  setFormData({ ...formData, taskManager: value })
                  console.log(value)
                  console.log(formData)
                }}
              >
                <SelectTrigger className="w-full border border-slate-200 rounded-lg text-slate-900">
                  <SelectValue placeholder="Attribuer à un (ou plusieurs) utilisateur(s)" />
                </SelectTrigger>
                <SelectContent>
                  <SelectGroup>
                    <SelectLabel className="bg-white">Utilisateurs</SelectLabel>
                    {takers.map((user) => (
                      <SelectItem
                        className="bg-white"
                        key={user._id}
                        value={user.value}
                      >
                        {user.label}
                      </SelectItem>
                    ))}
                  </SelectGroup>
                </SelectContent>
              </Select> */}
            </div>
          </div>

          <DialogFooter className="flex justify-end gap-2 mt-6 pt-4 border-t border-slate-200">
            <Button
              type="button"
              variant="outline"
              onClick={() => onOpenChange(false)}
              className="border-slate-200 rounded-lg text-slate-700 hover:bg-slate-50"
            >
              Annuler
            </Button>
            <Button
              type="submit"
              className="bg-[#074b78] hover:bg-[#063b5e] text-white font-medium rounded-lg"
            >
              {!isUpdating && <span>Créer la tâche</span>}
              {isUpdating && <span>Mettre à jour la tâche</span>}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}

export default freshModal(TaskModalFormSession, "open");
